<template>
  <div class="privacyPolicy">
    <div style="word-break:break-all;" v-html="decodeStrConStr"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      decodeStrConStr:''
    }
  },
  created () {
    document.title = '隐私政策'
    if (this.environment.isFengChao) {
      this.$cjc.showNavigation()
    }
    this.getAppUserPrivacy()
  },
  methods: {
    async getAppUserPrivacy(){
      const {data: { result, status, msg }} = await this.$store.dispatch('getAppUserPrivacy',{})
      console.log(result);
      if (status === 1000) {
        this.decodeStrConStr = result.decodeStrCon
        console.log(this.decodeStrConStr);
      }else{
        this.$Message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss">
.privacyPolicy {
  height: 100vh;
  padding: 20px;
  // 是因为华为鸿蒙上架审核要求。作为V2.1.3版本发布
  -webkit-user-select: text;
  user-select: text;
}
</style>